import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  circularProgress: {
    color: theme.palette.greenPantone,
  },
}))

export default styles
